

import blogApi from "../utils/api/blogApi";

export async function getBlogs() {
  return (await blogApi.get("/blogs")).data;
}

export async function getBlog(id: number) {
  return (await blogApi.get(`/blogs/${id}`)).data;
}

export async function createBlog(formData: FormData) {
  const response = await blogApi.post("/blogs", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function updateBlog(id: number, formData: FormData) {
  const response = await blogApi.put(`/blogs/${id}`, formData, {
    headers: { "Content-Type": "multipart/form-data" }
  });
  return response.data;
}

export async function deleteBlog(id: number) {
  return (await blogApi.delete(`/blogs/${id}`)).data;
}